export enum ScheduleType {
    BirthDate = 'Birth Date',
    RelativeTaskDue = 'Relative Task-Due Date/Time',
    RelativeTaskComplete = 'Relative Task-Complete Date/Time'
}
